import React from "react";
import PropTypes from "prop-types";
import { isSafeImageSrc } from "../../../utils";
/**
 * MobileHealthArea component for displaying a health area in a mobile-friendly format.
 * @param {string} current - The name of the currently selected health area.
 * @param {Array} items - The list of available health area items with their names and content render functions.
 * @returns {JSX.Element} The rendered mobile health area component.
 */
export function NewMobileHealthArea({
  current,
  items,
  doctor,
  drImg,
  ...props
}) {

  const doctorImage = isSafeImageSrc(drImg) ? drImg : null;
  
  const renderContent = () => {
    const currentItem = items?.find((i) => i.name === current) || items[0];
    return currentItem?.content();
  };
  return (
    <main
      className={`horizontal-section-main ${
        current === "InsightsSection" ? "" : "result-card"
      }`}
      {...props}
    >
      {current === "doctor_notes" && (
        <header className="doctorLetter__doctor">
          {doctorImage !== null && (
            <img
              src={doctorImage}
              alt="doctor-image"
              style={{ width: 60, height: 60, borderRadius: "50%" }}
            />
          )}
          <div className="d-flex flex-column fs-14">
            <span style={{ color: "#6C757D" }}>Reviewed by</span>
            <span className="doctorLetter__doctor-name">Dr {doctor}</span>
          </div>
        </header>
      )}
      {renderContent()}

      <div className="healthArea__container"></div>
    </main>
  );
}

NewMobileHealthArea.propTypes = {
  current: PropTypes.string.isRequired,

  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      content: PropTypes.func.isRequired,
    })
  ).isRequired,
  props: PropTypes.object,
  doctor: PropTypes.string,
  drImg: PropTypes.string
};
